import { fabric } from 'fabric';

const Text = fabric.util.createClass(fabric.Textbox, '', {
  type: 'text',

  initialize(element, options) {
    options || (options = {});
    this.callSuper('initialize', element, options);

    // Set default options
    this.set({
      width: 300,
      rotateAngle: 0,
      hasRotatingPoint: false,
      fontSize: 14,
      fontFamily: 'euclid-flex',
      fontWeight: 400,
      cursorWidth: 1,
      originX: 'center',
      originY: 'center',
      textAlign: 'left',
      padding: 5,
      lockScalingY: true,
    });
  },

  toObject() {
    return fabric.util.object.extend(this.callSuper('toObject'), {
      customProps: this.customProps,
      rotateAngle: this.angle,
    });
  },
});

export default Text;



// WEBPACK FOOTER //
// ./library/app/components/Diagram/Items/Text.js